import { Redirect, useParams } from "react-router-dom";

export const RedirectToTask = () => {
    const { taskId } = useParams<{ taskId: string }>();

    return <Redirect to={`/overview/current/${taskId}`} />;
};
